import React from 'react';
import { RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { createIdFromLabel, generateRandomId } from '../../../utils/commonUtils';

const CustomActiveInactiveRadio = (props) => {
  const { item, handleRadioButton, options, className } = props;
  const values = options ?? [
    {
      id: 'active',
      name: 'Active',
    },
    {
      id: 'inactive',
      name: 'Inactive',
    },
  ];
  const fieldId = item.fieldName ? createIdFromLabel(item.fieldName) : generateRandomId();

  const onChange = (e) => {
    const inputValue = e.target.value;
    const currField = { ...item };
    currField.value = inputValue;
    handleRadioButton(currField);
  };

  return (
    <div className='custom-active-inactive-radio'>
      <RadioGroup
        row
        aria-label={fieldId}
        onChange={(e) => {
          onChange(e);
        }}
        value={item.value}
        className='hotel-service-radio-group'
        name={fieldId}
      >
        {values?.map((item) => (
          <FormControlLabel
            key={item.id}
            value={item.id}
            control={<Radio color='primary' />}
            label={item.name}
            className={className}
          />
        ))}
      </RadioGroup>
    </div>
  );
};

export default CustomActiveInactiveRadio;
